import { render, staticRenderFns } from "./detail-reply.vue?vue&type=template&id=4824f132&"
import script from "./detail-reply.vue?vue&type=script&lang=js&"
export * from "./detail-reply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports